'use client';

import { ScrollAnimation } from '@/shared/components/ui/scroll-animation';
import { cn } from '@/shared/lib/utils';
import { Section } from '@/shared/types/blocks/landing';

// Playful colors for stat cards
const statColors = [
  'bg-primary/10 border-primary/20',
  'bg-accent/20 border-accent/30',
  'bg-chart-4/20 border-chart-4/30',
  'bg-chart-3/20 border-chart-3/30',
];

export function Stats({
  section,
  className,
}: {
  section: Section;
  className?: string;
}) {
  return (
    <section
      id={section.id}
      className={cn('py-12 md:py-24', section.className, className)}
    >
      <div className={`container space-y-8 md:space-y-16`}>
        <ScrollAnimation>
          <div className="relative z-10 mx-auto max-w-xl space-y-6 text-center">
            <span className="text-primary text-sm font-bold tracking-wider uppercase">
              {(section as any).label}
            </span>
            <h2 className="text-foreground mt-4 mb-4 text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
              {section.title}
            </h2>
            <p className="text-muted-foreground mb-6 text-lg md:mb-12 lg:mb-16">
              {section.description}
            </p>
          </div>
        </ScrollAnimation>

        <ScrollAnimation delay={0.2}>
          <div className="grid gap-6 md:grid-cols-3 lg:grid-cols-4">
            {section.items?.map((item, idx) => (
              <div
                className={cn(
                  'card-playful soft-shadow border-2 p-8 text-center',
                  statColors[idx % statColors.length]
                )}
                key={idx}
              >
                <h3 className="sr-only">
                  {item.title} {item.description}
                </h3>
                {item.emoji && (
                  <div className="mb-4 text-4xl">{item.emoji}</div>
                )}
                <div className="gradient-text mb-2 text-5xl font-bold">
                  {item.title}
                </div>
                <p className="text-muted-foreground">{item.description}</p>
              </div>
            ))}
          </div>
        </ScrollAnimation>
      </div>
    </section>
  );
}
